import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'

import { MessagingTypes } from '../../actions'

export const INITIAL_STATE = Immutable({
  newMessage: '',
  messages: [],
  unreadMessages: 0,
})

const updateMessage = (state, action) => state.merge({ newMessage: action.messageText })

const displayMessage = (state, { details }) =>
  state.merge({
    newMessage: details.type === 'user' ? INITIAL_STATE.newMessage : state.newMessage,
    messages: [
      ...state.messages,
      {
        text: details.text || '',
        type: details.type,
        name: details.name || '',
        delay: details.delay || 0,
        timestamp: details.timestamp || Date.now(),
        ...(details.type === 'system' && { masked: details.masked }),
      },
    ],
  })

const displayFileMessage = (state, { details }) =>
  state.merge({
    newMessage: details.type === 'user' ? INITIAL_STATE.newMessage : state.newMessage,
    messages: [
      ...state.messages,
      {
        text: details.text || '',
        type: details.type,
        name: details.name || '',
        fileInfo: details.fileInfo,
        delay: details.delay || 0,
        timestamp: details.timestamp || Date.now(),
      },
    ],
  })

const clearMessages = (state) => state.merge({ messages: INITIAL_STATE.messages })

const addUnreadMessage = (state) => state.merge({ unreadMessages: state.unreadMessages + 1 })

const clearUnreadMessages = (state) => state.merge({ unreadMessages: 0 })

const ACTION_HANDLERS = {
  [MessagingTypes.UPDATE_MESSAGE]: updateMessage,
  [MessagingTypes.DISPLAY_MESSAGE]: displayMessage,
  [MessagingTypes.DISPLAY_FILE_MESSAGE]: displayFileMessage,
  [MessagingTypes.ADD_UNREAD_MESSAGE]: addUnreadMessage,
  [MessagingTypes.CLEAR_UNREAD_MESSAGES]: clearUnreadMessages,
  [MessagingTypes.CLEAR_MESSAGES]: clearMessages,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
